import "Layouts/default";

import Swiper, { Pagination, Navigation } from "swiper";

import "Ui/slider";
import "Components/seen-products";

Swiper.use([Pagination, Navigation]);
